<template lang="pug">
  app-modal(
    :hasFooter="false",
    :closeOutside="false",
    titulo="Visualizar demanda",
    :width="800",
    @closeModal="closeModal"
  )
    template(slot="body")
      el-row(:gutter="20").container
        el-col(:span="8")
          span.label Número da demanda:
          span {{ demanda.numeroDemanda }}

      el-row(:gutter="20").container
        el-col(:span="24")
          span.label Painel:
          span {{ getPainelNome }}

      el-row(:gutter="20").container
        el-col(:span="24")
          span.label Nome da demanda:
          span {{ demanda.nome }}

      el-row(:gutter="20").container
        el-col(:span="12")
          span.label Data de início:
          span {{ formatarData(demanda.dataInicio) }}
        el-col(:span="12")
           span.label Data de entrega:
           span {{ formatarData(demanda.dataEntrega) }}

      el-row(:gutter="20").container
        el-col(:span="12")
         span.label Estado da demanda:
         span {{ getEstadoDemanda }}
        el-col(:span="6")
         span.label Prioridade:
         el-tag.tag.demanda-text-color(:color="getPrioridadeColor") {{ getPrioridade }}
        el-col(:span="6")
         span.label Situação:
         el-tag(:type="getSituacaoType" effect='dark') {{ getSituacao }}

      el-row(:gutter="20" v-if="demanda.descricao").container
        el-col(:span="24")
         span.label Descrição:
         div.container-disable
          p {{ demanda.descricao }}

      el-row(:gutter="20" v-if="getAtividades").container
        el-col(:span="24")
         span.label Atividades:
         div.container-disable
          ul.vertical-ul
            li(v-for="atividade in getAtividades")
              el-row
                el-col(:span="1")
                  el-checkbox(v-model="atividade.concluido" disabled )
                el-col(:span="23")
                  span {{atividade.nome}}

      el-row(:gutter="20").padding-horizontal-10
        el-col(:span="24")
          span.label Responsáveis:
          template
            ul.horizontal-ul(v-if="getResponsaveis")
              li(v-for="responsavel in getResponsaveis")
                el-tag.tag.responsavel-text-color {{responsavel.pessoa.nomeRazaoSocial}}
            span(v-else) Não há responsáveis informados para esta demanda.
</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'
import Utils from '@/utils/utils'

export default {
  data () {
    return {
      demanda: {
        nome: '',
        responsaveis: [],
        dataInicio: null,
        dataEntrega: null,
        estadoDemanda: null,
        prioridade: null,
        descricao: '',
        atividades: []
      }
    }
  },

  props: {
    idDemanda: {
      required: false
    }
  },

  computed: {
    getPrioridadeColor: function () {
      return this.demanda.prioridade ? this.demanda.prioridade.codigo : ''
    },

    getPrioridade: function () {
      return this.demanda.prioridade ? this.demanda.prioridade.nome : '-'
    },

    getResponsaveis: function () {
      return this.demanda.responsaveis && this.demanda.responsaveis.length > 0 ? this.demanda.responsaveis : null
    },

    getAtividades: function () {
      return this.demanda.atividades && this.demanda.atividades.length > 0 ? this.demanda.atividades : null
    },

    getSituacaoType: function () {
      return this.demanda.demandaAVencer ? 'warning' : this.demanda.dataEntregaJaPassou ? 'danger' : 'success'
    },

    getSituacao: function () {
      return this.demanda.demandaAVencer ? 'A vencer' : this.demanda.dataEntregaJaPassou ? 'Atrasada' : 'Em dia'
    },

    getEstadoDemanda: function () {
      return this.demanda.estadoDemanda ? this.demanda.estadoDemanda.nome : ' - '
    },

    getPainelNome: function () {
      return this.demanda.painel ? this.demanda.painel.nome : ' - '
    }
  },

  methods: {
    ...mapActions({
      findById: 'demandas/findById'
    }),

    closeModal () {
      this.$emit('closeModal')
    },

    callbackSucesso () {
      this.$emit('callbackSucesso')
    },

    formatarData (date) {
      return date !== null ? Utils.formatDate(date, 'DD/MM/YYYY') : ' - '
    }
  },

  created () {
    if (this.idDemanda) {
      this.findById(this.idDemanda).then(response => {
        this.demanda = response
      })
    }
  },

  components: {
    AppModal,
    AppLabel
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
@import "@/assets/styles/_variables.scss";

.container {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
}

.padding-horizontal-10 {
  padding: 0 10px;
}

.last {
  padding-bottom: 15px;
}

.container-disable {
  padding: 5px;
  overflow-y: auto;
  height: 100px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #dcdfe6;
}

.vertical-ul {
  padding: 0px;
  margin-top: 2px;
  list-style: none;
}

.vertical-ul li {
  padding: 4px;
}

.horizontal-ul {
  padding: 0px;
  margin-top: 5px;
  list-style: none;

  li {
    margin-bottom: 10px;
  }
}

.tag {
  background-color: #dcdfe6;
  border: none;
}

.responsavel-text-color {
  color: gray;
}

.demanda-text-color {
  color: white;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

span {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/ModalVisualizarDemanda.vue